"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformUserAuthPayloadToUserJWT = void 0;
const transformUserAuthPayloadToUserJWT = (userAuthPayload) => ({
    userId: userAuthPayload.userId,
    appName: userAuthPayload.appName,
    roles: userAuthPayload.roles && userAuthPayload.roles.length ? userAuthPayload.roles : [],
    roleDetails: userAuthPayload.roleDetails ? userAuthPayload.roleDetails : {},
    refreshRoles: userAuthPayload.refreshRoles ? userAuthPayload.refreshRoles : undefined,
    data: userAuthPayload.data,
    iat: userAuthPayload.iat,
});
exports.transformUserAuthPayloadToUserJWT = transformUserAuthPayloadToUserJWT;
//# sourceMappingURL=transformUserAuthPayloadToUserJWT.js.map